import EnergyLabel from "@JohnLewisPartnership/jl-design-system/dist/components/energy-rating/EnergyRating";
import styles from "../../EnergyLabel.module.scss";
import { ArrowRightOutlined as ArrowRight } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ArrowRightOutlined";
import { ListItem as ListItemShared } from "../../../__shared__/ListItem/ListItem";
import cx from "classnames";

export type ListItemProps = {
  className?: string;
  handleClick?: () => void;
  isLegacy: boolean;
  rating: string;
  dataComponent?: string;
};

export const ListItem = ({
  className,
  handleClick,
  isLegacy,
  rating,
  dataComponent,
}: ListItemProps) => {
  const classNames = cx(styles.energyLabelItem, className);

  return (
    <ListItemShared
      leadingIcon={
        <EnergyLabel
          rating={isLegacy ? undefined : rating}
          ratingLegacy={isLegacy ? rating : undefined}
          className={styles.energyLabelIcon}
        />
      }
      trailingIcon={
        handleClick ? (
          <ArrowRight dataTestId={"energy-rating-arrow"} size="medium" />
        ) : undefined
      }
      label={
        <>
          Energy rating: <span className={styles.rating}>{rating}</span>
        </>
      }
      onClick={handleClick}
      className={classNames}
      dataComponent={dataComponent}
    />
  );
};
